export default {
    DEFAULT: 'DEFAULT',
    SUAMI: 'SUAMI',
    ISTRI: 'ISTRI',
    ANAK: 'ANAK',
    KAKAK: 'KAKAK',
    ADIK: 'ADIK',
    LAINNYA: 'LAINNYA',
}
